import React from 'react';
import { Mail, MailCheck, MailWarning } from 'lucide-react';
import type { ChipTon, MailVermerk, StatusChip } from '../../../services/material/materialLogic';

/** Chips wie in der Druckliste des Plotters (PlotterPapierVerwaltung). */
const CHIP = 'inline-block text-[11px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap';

const TON: Record<ChipTon, string> = {
    offen: 'bg-amber-100 text-amber-800',
    bestellt: 'bg-blue-100 text-blue-700',
    erledigt: 'bg-emerald-100 text-emerald-700',
    leer: 'bg-slate-100 text-slate-500',
};

export const StatusChipAnzeige: React.FC<{ chip: StatusChip }> = ({ chip }) => (
    <span className={`${CHIP} ${TON[chip.ton]}`}>{chip.text}</span>
);

export const AktivChip: React.FC<{ aktiv: boolean }> = ({ aktiv }) => (
    <span className={`${CHIP} ${aktiv ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-200 text-slate-600'}`}>
        {aktiv ? 'aktiv' : 'deaktiviert'}
    </span>
);

export const MailVermerkAnzeige: React.FC<{ vermerk: MailVermerk }> = ({ vermerk }) => {
    const Icon = vermerk.art === 'zugestellt' ? MailCheck : vermerk.art === 'fehler' ? MailWarning : Mail;
    const farbe = vermerk.art === 'zugestellt' ? 'text-emerald-700' : vermerk.art === 'fehler' ? 'text-red-700' : 'text-slate-400';
    return (
        <span className={`inline-flex items-start gap-1.5 ${farbe}`}>
            <Icon className="w-3.5 h-3.5 shrink-0 mt-px" aria-hidden />
            <span className="break-words">{vermerk.text}</span>
        </span>
    );
};
